import { Component, Input } from '@angular/core';
import { PhxTriggerType } from 'phx-core';
import type { PhxTooltipPlacement } from 'phx-core';

export type PopupIconType = 'warning' | 'note' | 'pending' | 'info-i' | 'claim';

@Component({
  selector: 'info-popup',
  templateUrl: './info-popup.component.html',
  styleUrls: ['./info-popup.component.scss'],
})
export class InfoPopupComponent {
  @Input() public placement: PhxTooltipPlacement = 'top';
  @Input() public icon: PopupIconType;
  @Input() public useCustomIcon: boolean = false;
  @Input() public trigger: PhxTriggerType = 'hover';
  @Input() public disabled: boolean = false;
}
